<template>
  <span class="port-dots" :title="`已用 ${used} / 共 ${capacity}`">
    <i
      v-for="(inUse, idx) in dots"
      :key="idx"
      class="port-dot"
      :class="inUse ? 'port-dot--used' : 'port-dot--free'"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ used: number; capacity: number }>();

const dots = computed(() => {
  const total = Math.max(0, Math.min(props.capacity, 20));
  const used = Math.max(0, Math.min(props.used, total));
  return Array.from({ length: total }, (_, idx) => idx < used);
});
</script>

<style scoped>
.port-dots { display: inline-flex; gap: 4px; vertical-align: middle; }
.port-dot { width: 9px; height: 9px; border-radius: 50%; display: inline-block; }
.port-dot--used { background: #ef4444; }
.port-dot--free { background: #22c55e; }
</style>
